<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center">View Package</h3>
        </v-flex>
        <v-flex xs12 sm6 md6 class="pa-1">
          <v-card>
            <v-card-text>
              <show-package :package="packaged"></show-package>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small text @click="goTo('/packages/' + packaged.id + '/edit')" title="Edit Package" class="orange">
                <v-icon left>mdi-pencil</v-icon>Edit
              </v-btn>
              <v-btn small text @click="deletePackage(packaged)" title="Delete Package" class="red">
                <v-icon left>mdi-delete-empty</v-icon>Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm11 md11>
          <v-card>
            <v-card-text>
              <show-requests-table :service_requests="service_requests"></show-requests-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ShowPackage = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "pricing-packages" */ '@/Components/Packages/show')
  const ShowRequestsTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "pricing-packages" */ '@/Components/ServiceRequest/index')

  export default {
    name: 'ViewPackage',
    layout,
    props: [
      'package', 'service_requests'
    ],
    components: {
      ShowPackage,
      ShowRequestsTable,
    },
    metaInfo () {
      return {
        title: 'View Package',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      deletePackage (packa) {
        if (confirm('Are you sure you want to delete this package?')) {
          this.$inertia.delete('/packages/' + packa.id)
        }
      },
    },
    computed: {
      packaged () {
        return this.package
      },
    }
  }
</script>
